/**
 * @generated SignedSource<<3638b16057167bc8358795719e7d8a2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CaseDeleteMutation$variables = {
  id: string;
};
export type CaseDeleteMutation$data = {
  readonly softDelete: {
    readonly success: boolean | null;
  } | null;
};
export type CaseDeleteMutation = {
  response: CaseDeleteMutation$data;
  variables: CaseDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "SoftDelete",
    "kind": "LinkedField",
    "name": "softDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CaseDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CaseDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "744ba8fb7f02f39e7cc7beb5d7b9a20f",
    "id": null,
    "metadata": {},
    "name": "CaseDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation CaseDeleteMutation(\n  $id: ID!\n) {\n  softDelete(id: $id) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "6122044dd89a1117b7f96db6c6c5511b";

export default node;
